export default __webpack_public_path__ + "static/media/eudelegationH_dark.ddfc7a30.png";